import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icons';

/**
 * HeroStatTile - one of the small stat tiles that sits inside a page hero.
 * Mirrors the v0.7 stat tile pattern (index.html line ~1958): icon chip
 * on the left, label/value/sub stack on the right, white-on-gradient.
 *
 * Designed to render inside the `bdse-hero-stats` flex container. Each
 * tile is fluid (`flex: 1 1 130px`) so the row reflows to any tile count.
 */
export function HeroStatTile({
  label,
  value,
  sub,
  icon,
}: {
  label: string;
  value: ReactNode;
  sub: string;
  icon: IconName;
}) {
  return (
    <div className="bdse-stat-tile">
      <div className="bdse-stat-icon">
        <Icon name={icon} />
      </div>
      <div className="bdse-stat-body">
        <div className="bdse-stat-label">{label}</div>
        <div className="bdse-stat-value">{value}</div>
        <div className="bdse-stat-sub">{sub}</div>
      </div>
    </div>
  );
}
